import { Box, CircularProgress } from '@mui/material';
import ProductLogo from '../ProductLogo/ProductLogo';
import Style from './LoadingFullPage.module.scss';

const LoadingFullPage = (): React.ReactElement => {
    return (
        <Box className={Style['loading-full-page']}>
            <div>
                <ProductLogo />
                <CircularProgress size={50} />
            </div>
        </Box>
    );
};

export default LoadingFullPage;
